module.exports = __webpack_public_path__ + "img/logo-light.996ed40d.png";